import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyD7r3y8MJ8FJAoOsF2uLVtgQxvMBxM3CK0",
    authDomain: "petgroomoz.firebaseapp.com",
    projectId: "petgroomoz",
    storageBucket: "petgroomoz.firebasestorage.app",
    messagingSenderId: "590783565272",
    appId: "1:590783565272:web:284ce59def5c273c8bf6ad",
    measurementId: "G-34L57QD0B5"
  };

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }